import css from 'styled-jsx/css';

const styles = css.global`#energia-solar-vantagens {
  overflow: hidden;
  padding-bottom: 40px;
  padding-top: 40px;
}

#energia-solar-vantagens .ctn-home-24 {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

#energia-solar-vantagens .passo-a-passo-titulo {
  margin: 0;
  color: #444;
  font-family: 'SantanderHeadline';
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 42px;
}

#energia-solar-vantagens .passo-a-passo-carrossel .slide {
  display: flex;
  gap: 24px;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  height: 248px;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid #444;
  margin-right: 24px;
  width: 240px;
  flex: 0 0 240px;
}

#energia-solar-vantagens .passo-a-passo-carrossel .slide-icon {
  margin: 0 auto;
  display: block;
  object-fit: contain;
  width: auto;
  height: 40px;
}

#energia-solar-vantagens .passo-a-passo-carrossel .slide .slide-numero {
  color: #739e41;
  text-align: center;
  font-family: 'SantanderText';
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: 60px;
}

#energia-solar-vantagens .passo-a-passo-carrossel .slide .slide-textos {
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: flex-start;
  height: 228px;
}

#energia-solar-vantagens .passo-a-passo-carrossel .slide .slide-titulo {
  color: #444;
  font-family: 'SantanderHeadline';
  font-size: 18px;
  font-style: normal;
  font-weight: 800;
  line-height: 28px;
  text-align: center;
}

#energia-solar-vantagens .passo-a-passo-carrossel .slide .slide-texto {
  color: #444;
  font-family: 'SantanderText';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
}

#energia-solar-vantagens .home-pagination {
  margin-top: 24px;
  max-width: 304px;
}

#energia-solar-vantagens .home-pagination .embla__prev.enable-mobile-arrows,
#energia-solar-vantagens .home-pagination .embla__next.enable-mobile-arrows {
  width: 24px;
  height: 24px;
  background-size: 24px 24px;
}

#energia-solar-vantagens .pagination-container .bullet {
  background-color: #222;
}

#energia-solar-vantagens .pagination-container .bullet.active,
#energia-solar-vantagens .pagination-container .bullet[selected] {
  background-color: #739e41;
}

@media (min-width: 992px) {
  #energia-solar-vantagens {
    padding-top: 48px;
    padding-bottom: 64px;
  }

  #energia-solar-vantagens .ctn-home-24 {
    gap: 40px;
  }

  #energia-solar-vantagens .passo-a-passo-titulo {
    font-size: 40px;
    line-height: 60px;
  }

  #energia-solar-vantagens .passo-a-passo-carrossel .custom-carousel {
    /* margin-top: 16px; */
    overflow: hidden;
  }

  #energia-solar-vantagens .passo-a-passo-carrossel .slide,
  #energia-solar-vantagens .passo-a-passo-carrossel .slide:first-child {
    width: calc(25% - 18px);
    flex: 0 0 calc(25% - 18px);
    height: auto;
  }

  #energia-solar-vantagens .passo-a-passo-carrossel .slide:last-of-type {
    margin-right: 0;
  }

  #energia-solar-vantagens .passo-a-passo-carrossel .slide .slide-textos {
    height: 100%;
  }

  #energia-solar-vantagens .home-pagination {
    margin-top: 64px;
    display: none !important;
  }
}

@media (min-width: 1200px) {
  #energia-solar-vantagens .passo-a-passo-carrossel .slide,
  #energia-solar-vantagens .passo-a-passo-carrossel .slide:first-child {
    width: calc(33% - 120px);
    flex: 0 0 calc(33% - 120px);
    height: auto;
  }

  #energia-solar-vantagens .passo-a-passo-carrossel .slide:nth-child(3) {
    width: 300px;
    flex: 0 0 300px;
  }
}
`;

export default styles;